import styled from "styled-components";
import { Link } from "react-router-dom";

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Row = styled(Link)`
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: grid;
  gap: 10px;
  grid-template-columns: 18px 56px 1fr;
  text-decoration: none;
`;

export const RankBadge = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
`;

export const Thumbnail = styled.div<{ $src?: string }>`
  aspect-ratio: 16 / 9;
  background: ${({ theme, $src }) =>
    $src ? `url(${$src}) center / cover no-repeat` : theme.colors.midnight};
  border-radius: 6px;
  flex-shrink: 0;
  width: 56px;
`;

export const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ItemTitle = styled.div`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 13px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ItemMeta = styled.div`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 11.5px;
`;
